import { render, staticRenderFns } from "./CompetenciesInputSelection.vue?vue&type=template&id=de157618&scoped=true"
import script from "./CompetenciesInputSelection.vue?vue&type=script&lang=js"
export * from "./CompetenciesInputSelection.vue?vue&type=script&lang=js"
import style0 from "./CompetenciesInputSelection.vue?vue&type=style&index=0&id=de157618&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de157618",
  null
  
)

export default component.exports